import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProfileCard from '../../../components/ProfileCard/ProfileCard'
import Profiledetails from './Profiledetails';
import Settings from './Settings';
import '../../Mentor/MnMyProfile/MnMyProfileStyle.css'
import { useEffect } from 'react';
import { changePassword, clearState, getParticularUser, menteeData, updateUserDetails } from '../../../reducer/menteeSlice';
import { useDispatch, useSelector } from 'react-redux';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import ErrorToast from '../../../components/Toast/ErrorToast';
import SuccessToast from '../../../components/Toast/SuccessToast';
import Skeleton from 'react-loading-skeleton';
import * as filestack from 'filestack-js';

function MeMyProfile() {

    //Edit Profile Templates
    const template = {
        profileImg: "",
        firstName: "",
        lastName: "",
        title: "work",
        designation: "",
        company: "",
        mobileNumber: "",
        email: "",
        yrsOfExp: "",
      };
      const errorTemplate = {
        firstName: "",
        title: "",
        company: "",
        designation: "",
        yrsOfExp: "",
        mobileNumber: "",
        email: "",
      };

      //Change pass templates
    const changePassTemplate = {
        password: "",
        newPassword: "",
        confirmPassword: "",
    }

    const [TabSlotProfile, setTabSlotProfile] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [menteeDetails, setMenteeDetails] = useState(template);
    const [errorAddMentee, setErrorAddMentee] = useState(errorTemplate);

    //ChangePassword States
    const [changePassToggler, setChangePassToggler] = useState(1);
    const [password, setPassword] = useState(changePassTemplate);
    const [errorPassword, setErrorPassword] = useState(changePassTemplate);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isFetching, isSuccess, isError, errorMessage, particularUser } = useSelector(menteeData);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if(name === "mobileNumber" && (value?.length > 10 || value < 0)) return;
        setMenteeDetails(prev => ({
            ...prev,
            [name]: value
        }))
    };

    const handleDropdownChange = (e) => {
        setErrorAddMentee(errorTemplate);
        const { name, value } = e.target;
        setMenteeDetails(prev => ({
          ...prev,
          [name]: value
        }))
      }

    const handleUploadProfile = () => {
        const client = filestack.init("AASYllbvHQ3u0A1GxbOvZz");

        client.picker({
            accept: ['image/*'],
            onUploadDone: (result) => {
                if (result?.filesFailed?.length > 0) {
                    setIsShowError(true);
                    setErrMessage("Something went wrong")
                }
                if (result?.filesUploaded?.length > 0) {
                    setMenteeDetails(prev => ({
                        ...prev,
                        profileImg: result?.filesUploaded[0]?.url
                    }));
                }
            },
        }).open();
      };

      const handleDiscard = () => {
        setMenteeDetails({
            profileImg: particularUser?.profileImg ?? "",
            firstName: particularUser?.firstName ?? "",
            lastName: particularUser?.lastName ?? "",
            title: particularUser?.profession?.title ?? "",
            designation: particularUser?.profession?.designation ?? "",
            company: particularUser?.profession?.company ?? "",
            yrsOfExp: particularUser?.profession?.yrsOfExp ?? "",
            mobileNumber: particularUser?.mobileNumber ?? "",
            email: particularUser?.email ?? "",
        });
      };
    
      const handleSave = () => {
        setTabSlotProfile(1);
          dispatch(updateUserDetails(menteeDetails));
      };

      //Change Password Functions
    const handleShowChangePass = () => {
        setChangePassToggler(2);
    };

    const handleCancelChangePass = () => {
        setPassword(changePassTemplate);
        setErrorPassword(changePassTemplate);
        setChangePassToggler(1);
    }

    const handlePassChange = (e) => {
        setErrorPassword(changePassTemplate);
        const { name, value } = e.target;
        setPassword(prev => ({
            ...prev,
            [name]: value
        }))
    };

    const validatePassword = () => {
        for (const key in password) {
            if (!password[key]) {
                setErrorPassword(prev => ({
                    ...prev,
                    [key]: "Please fill this field"
                }));
                return true;
            }
        }
        if(password["confirmPassword"] !== password["newPassword"]) {
            setErrorPassword(prev => ({
                ...prev,
                confirmPassword: "Password do not match!"
            }));
            return true;
        }
        if(password["newPassword"].length < 6) {
            setErrorPassword(prev => ({
                ...prev,
                newPassword: "Password should be atleast 6 digit long!"
            }));
            return true;
        }
        if(password["newPassword"] === password["password"]) {
            setErrorPassword(prev => ({
                ...prev,
                newPassword: "New password cannot be same as the old!"
            }));
            return true;
        }
        return false;
    };

    const handlePassChangeConfirm = () => {
        if(!validatePassword()) {
            dispatch(changePassword(password));
        }
    };

    const handlePassPressConfirm = (e) => {
        if(e.key === "Enter") {
            if(!validatePassword()) {
                dispatch(changePassword(password));
            }
        }
    }

    useEffect(() => {
        dispatch(getParticularUser({user: "mentee",userId: localStorage.getItem("userId")}));
    },[]);

    useEffect(() => {
        setMenteeDetails({
            profileImg: particularUser?.profileImg ?? "",
            firstName: particularUser?.firstName ?? "",
            lastName: particularUser?.lastName ?? "",
            title: particularUser?.profession?.title ?? "",
            designation: particularUser?.profession?.designation ?? "",
            company: particularUser?.profession?.company ?? "",
            yrsOfExp: particularUser?.profession?.yrsOfExp ?? "",
            mobileNumber: particularUser?.mobileNumber ?? "",
            email: particularUser?.email ?? "",
        });
    },[particularUser]);

    useEffect(() => {
        if(isSuccess) {
            setPassword(changePassTemplate);
            setErrorPassword(changePassTemplate);
            setIsShowSuccess(true);
            setSuccessMessage("Success!");
            setChangePassToggler(1);
            setTabSlotProfile(1);
            dispatch(getParticularUser({user: "mentee",userId: localStorage.getItem("userId")}));
            dispatch(clearState());
        }
    },[isSuccess]);
    
    useEffect(() => {
        if(isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    },[isError])

    return (
        <>
        {/* {isFetching && <PageLoader />} */}
        <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <SuccessToast
        show={isShowSuccess}
        setShow={() => setIsShowSuccess(false)}
        message={successMessage}
      />
        <section className=''>
            <div className="DashboardWrapper">
                <div className="headingprofilewrap">
                    <h2 className='heading-2'>My Profile</h2>
                </div>

                <div className="flex-col Allcardboxwrapper mt-30">
                    <div className="profilewrapper w-100 ">
                        <div className="Adprofiledatawrapper flex-start">
                        {isFetching ? <Skeleton width={"150px"} height={"150px"} circle /> : <div className='Imageboxall'>
                                <img src={particularUser?.profileImg ? particularUser?.profileImg : "/assets/img/user2.jpeg"} alt="" />
                            </div>}
                            <div className="AdProfileDetailsarea">
                                <div className="headingwrap">
                                    <div className="headingorg flex gap-10">
                                        <h2 className='heading-2'>{isFetching ? <Skeleton width={"200px"} /> : particularUser?.firstName ? `${particularUser?.firstName} ${particularUser?.lastName}` : "---"}</h2>
                                        {particularUser?.linkedin &&<a target='_blank' href={particularUser?.linkedin.slice(0,4) === "http" ? particularUser?.linkedin : "https://" + particularUser?.linkedin} className='linkedintext' rel='noreferrer'>
                                            <span className='flex gap-2'>
                                                Linkedin
                                                <img src="/assets/img/send.png" alt="" />
                                            </span>
                                        </a>}
                                    </div>
                                    <div className="AdPsnlDetailsMentors mt-10">
                                    {isFetching ? <Skeleton width={"100px"} height={"10px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/usermentor.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.profession?.title ? particularUser?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                        </div>}
                                        {isFetching ? <Skeleton width={"200px"} height={"10px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/emailprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.email ? particularUser?.email : "---"}</p>
                                        </div>}
                                        {isFetching ? <Skeleton width={"150px"} height={"10px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/callprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.mobileNumber ?particularUser?.mobileNumber : "---"}</p>
                                        </div>}
                                    </div>
                                </div>
                                <div className="AdCardsProfilWrapper flex gap-10 mt-40">
                                {isFetching ?
                                    <div className={`CardContactWrapper`}>
                                    <span className='Adicontoolsicons flex-center'>
                                        {<Skeleton width={"50px"} height={"50px"} circle />}
                                    </span>
                                    <div className="contentareacontact">
                                        <Skeleton width={"40px"} height={"20px"} />
                                        <Skeleton width={"100px"} height={"15px"} />
                                    </div>
                                </div>
                                : <ProfileCard number={particularUser?.noOfCalls ?? 0} text={'Number of Calls'} img={"/assets/img/yellowcall.png"} />}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="AdMenusTabWrapper w-100 mt-40">
                        <ul className='flex gap-30 items-center'>
                            <li onClick={() => setTabSlotProfile(1)} className={TabSlotProfile === 1 && 'active'}>Profile Details</li>
                            <li onClick={() => setTabSlotProfile(2)} className={TabSlotProfile === 2 && 'active'}>Settings</li>
                        </ul>
                    </div>

                </div>

            </div>

            <Profiledetails isActiveTab={TabSlotProfile === 1 && 'active'} data={particularUser} setIsActive={setTabSlotProfile} isFetching={isFetching} />
            <Settings isActiveTab={TabSlotProfile === 2 && 'active'} changePassToggler={changePassToggler} password={password} errorPassword={errorPassword} addMentee={menteeDetails} errorAddMentee={errorAddMentee} handleChange={handleChange} handleDropdownChange={handleDropdownChange} handleProfileDiscard={handleDiscard} handleProfileSave={handleSave} handleUploadProfile={handleUploadProfile} handlePassChange={handlePassChange} handleShowChangePass={handleShowChangePass} handleCancelChangePass={handleCancelChangePass} handlePassChangeConfirm={handlePassChangeConfirm} handlePassPressConfirm={handlePassPressConfirm} />

        </section>
        </>
    )
}

export default MeMyProfile